import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PasswordStrengthMeterComponent } from './password-strength-meter.component';
import { PSMProgressBarDirective } from './psm-progress-bar.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [PasswordStrengthMeterComponent, PSMProgressBarDirective],
  exports: [PasswordStrengthMeterComponent, PSMProgressBarDirective],
})
export class PasswordStrengthMeterModule {
  static forRoot(): ModuleWithProviders<PasswordStrengthMeterModule> {
    return {
      ngModule: PasswordStrengthMeterModule,
    };
  }

  static forChild(): ModuleWithProviders<PasswordStrengthMeterModule> {
    return {
      ngModule: PasswordStrengthMeterModule,
    };
  }
}
